import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgApolloRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 31 31",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 4.86719,
			y: 4.3877,
			width: 21.5531,
			height: 21.5531,
			rx: 4.66013,
			fill: "#F8FF2C"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#000",
			d: "M16.3499 7.33797L16.3524 13.092C16.3527 14.0011 15.3987 14.5839 14.6061 14.1588L8.91602 11.1079C9.34998 10.3838 9.89569 9.73642 10.5284 9.18933L14.991 13.3706C15.2275 13.5921 15.6003 13.352 15.5029 13.0409L13.7722 7.51592C14.3548 7.37521 14.9623 7.30029 15.5872 7.30029C15.8446 7.30029 16.0989 7.31326 16.3499 7.33797Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#000",
			d: "M14.8072 23.0761L14.8047 17.351C14.8043 16.442 15.7584 15.8592 16.551 16.2842L22.2431 19.3363C21.8062 20.0584 21.258 20.7037 20.6228 21.2483L16.166 17.0724C15.9296 16.8509 15.5568 17.0911 15.6542 17.4021L17.3783 22.9062C16.8039 23.0429 16.205 23.1155 15.5894 23.1155C15.3254 23.1155 15.0644 23.1021 14.8072 23.0761Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#000",
			d: "M17.4036 14.6269L21.5366 10.0937C20.9973 9.44983 20.3586 8.89434 19.644 8.45239L16.626 14.2366C16.2067 15.0402 16.7818 16.0074 17.6785 16.007L23.3487 16.0044C23.3746 15.7425 23.388 15.4767 23.388 15.2078C23.388 14.5825 23.3161 13.9742 23.1807 13.3908L17.7289 15.1458C17.422 15.2445 17.1851 14.8666 17.4036 14.6269Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#000",
			d: "M7.81807 14.4386L13.4711 14.436C14.3679 14.4357 14.9428 15.4028 14.5236 16.2063L11.5212 21.9608C10.8093 21.5199 10.1727 20.9665 9.63515 20.3251L13.7461 15.8161C13.9646 15.5764 13.7276 15.1985 13.4208 15.2972L7.99317 17.0444C7.85489 16.4551 7.78125 15.8403 7.78125 15.208C7.78125 14.9483 7.79396 14.6917 7.81807 14.4386Z"
		})
	]
});
export default SvgApolloRegularIcon;
